import React, { Component, useEffect, useState } from 'react';
import OrderMerchantsView from './OrderMerchantsView'
import crmservices from '../../wsclient/crmservices';
import {setOrderCache,order_key,getOrderCache} from '../../utils/order_cache';
import t from '../../utils/translateUtil';
import { dataUtil, preferences_type } from '../../wsclient/crmservices/dataUtil';
function OrderMerchantsController(props){
            
    const [currentLocation, setCurrentLocation] = useState(null);
    const [showLoading, onShowLoading] = useState(true);
    const [showMerchantNearYou, onShowMerchantNearYou] = useState(false);
    const [stores, setStores] = useState([]);
    const [locationCheckTimer, setLocationChecTimer] = useState(null);
    const [initialRegion, setInitRegion] = useState({
        lat: 35.157322,
        lng: 33.313751
    });
    const [isRunning,setGetLocationStatus ] = useState('start');
    const [message, setMessage] = useState({});
    const [storeSelected, setStoreSelected] = useState(null);

    useEffect(()=>{
        if(isRunning=='start'){
            let locationCheckTimer = setInterval(() => getLocation(), 500)
            setLocationChecTimer(locationCheckTimer)
        }
        else{
            stopCheckingLocation()
        }
        return()=>clearInterval(locationCheckTimer);
    },[isRunning])

    useEffect(()=>{
        if(currentLocation){
            getStores();
            getRegion(currentLocation);
        }
    },[currentLocation])

    const getLocation = async() =>{
        await navigator.geolocation.getCurrentPosition((location) => {
            console.log("AAAAA location:",location);
            var currentLocation = {
                lat: 35.157322,
                lng: 33.313751
            }
            setCurrentLocation(currentLocation)
            stopCheckingLocation();
        }, (err) => {
            console.log('getLocation err', err)
            onShowLoading(false);
            stopCheckingLocation();
        }, {
            timeout: 5000,
            enableHighAccuracy: false
        });
    }
    const stopCheckingLocation = () =>{
        setGetLocationStatus('stop');
        if (locationCheckTimer) {
            clearInterval(locationCheckTimer);
        }
    }

    const onLoadFavouriteShop = async() =>{
        try {
            var result = await crmservices.contacts.getContactPreferences();
            console.log("onLoadFavouriteShop result:",result);
            if (result.code == 'OK') {
                setOrderCache(order_key.order_favourite_shop, result.data && result.data.organisations ? result.data.organisations : []);
            }
        } catch (error) {
            console.log('load favourite shop exception:', error);
        }
    }
    const addFavouriteShop = async(shop) =>{
        onShowLoading(true);
        try {
            var result = await crmservices.contacts.addContactPreferences(shop.id);
            if (result.code == 'OK') {
                await onLoadFavouriteShop();
            }else{
                props.showMessage(true, t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            console.log('add favourite shop exception:', error);
            props.showMessage(true, t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }

    const getRegion = (location) =>{
        if (location && location.lat && location.lon) {
            var region = {
                lat: Number(location.lat),
                lng: Number(location.lon)
            }
            setInitRegion(region)
        }
    }
    const getStores = async() =>{
        try {
            var delivery_address = getOrderCache(order_key.delivery_address);
            //console.log('delivery_address-====', delivery_address)

            var lat_lot = delivery_address.lat? delivery_address.lat + ":" + delivery_address.lon : null;
            var postal_code = delivery_address.postal_code? delivery_address.postal_code: null;
            // var result = await crmservices.rewards.getLocations({ lat: delivery_address.lat, lon: delivery_address.lon });
            var result = await crmservices.orders.orderFulfillment({ supply_method: "DELIVERY", address_id: delivery_address.id, lat_lot: lat_lot, postal_code: postal_code });
            //console.log("OrderMerchantsController result:", result);
            onShowLoading(false);
            if (result.code == 'OK') {
                // var stores = result.data.content;
                var stores = result.data.fulfilled_by;
                if (stores.length > 0)
                    setStores(stores);
                else {
                    setOrderCache(order_key.cart,[])
                    showMessage(true, t('FULFILL_ORDER_EMPTY_EXCEPTION'));
                }
            }
        } catch (error) {
            console.log("load merchants exception:", error);
        }
    }
    
    const onSelectMerchant = async (store) =>{
        getRegion(store.address);
        await setOrderCache(order_key.delivery_fulfilled_by,store);
        if(props.onReloadMenuItems){
            props.onReloadMenuItems()
        }
        props.onClose('open_menu');
    }
    const showMessage = (status, message) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }
    return (
        <OrderMerchantsView
            showLoading={showLoading}
            message={message}
            open={props.open}
            onClose={()=>props.onClose()}
            initialRegion={initialRegion}
            stores={stores}
            order_favourite_shop={dataUtil.filterContactPreferencesByType(getOrderCache(order_key.order_favourite_shop),preferences_type.order)}
            onSelectMerchant={onSelectMerchant}
            addFavouriteShop={addFavouriteShop}
            showMessage={showMessage}
        />
    );
}

export default OrderMerchantsController;